import { Close, Email, Folder, Language, Person, Phone, Place, Save, Web, WhatsApp } from '@mui/icons-material'
import { Box, Button, Divider, Icon, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Compartir from '../../componentes/Compartir'
import Mapa from '../../componentes/mapa/Mapa';
import { imgToUrl } from '../../lib/imgToUrl';

const VistaIzquierda = ({ datos, editable, setData, handleUpdate, setImgs }) => {
    const [mapa, setMapa] = useState('');

    useEffect(() => {
        if (mapa != '') {
            let obj = {
                target: {
                    value: mapa,
                    name: 'geolocalizacion'
                }
            }
            setData(obj);
        }
    }, [mapa]);

    const [logotipo, setLogotipo] = useState(Object.values(datos.imagenes).find(i => i.seccion == 'logotipo') ? Object.values(datos.imagenes).find(i => i.seccion == 'logotipo').url_img : null);
    const [galeria, setGaleria] = useState(Object.values(datos.imagenes).filter((i) => i.seccion === 'galeria' && i.paso == 'datos_generales'));
    const handleInput = (e, gal = false) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();

            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result
                if (gal) {
                    // setGaleria([...datos.galeria, imagen]);
                    setImgs([...datos.galeria, imagen]);
                } else {
                    // setLogotipo(imagen);
                    setImgs(imagen);
                }
            };

            reader.readAsDataURL(imagen);
        }
    }

    const removeImg = (index, id = null) => {
        if (Array.isArray(datos.galeria)) {
            let newGal = datos.galeria.filter((img, ind) => {
                if (img instanceof File) {
                    return ind !== index;
                } else {
                    return img.id != id;
                }
            });
            setImgs(newGal);
        }

    }

    // // cuando se modifique el una imagen, actualizar el objeto a enviar    
    // useEffect(() => {
    //     setImgs(datos.logotipo);
    //     // setData({target: 'datos_generales', value: {}});
    //     setImgs(datos.galeria);
    // }, [logotipo, galeria]);


    // agregar campo de figura juridica
    if (datos) {
        return (
            <Box>
                <Box sx={{ display: { xl: 'flex', xs: 'block' }, alignItems: 'center', mb: 2 }}>
                    {Object.values(datos.imagenes).filter(i => i.seccion == 'logotipo') && !editable &&
                        <Box sx={{ justifyContent: 'center', display: 'flex', mb: 2 }}>
                            <img width={'200px'} src={datos.logotipo ?? ''} alt={`Logotipo ${datos.nombre}`} />
                        </Box>
                    }
                    <Typography textAlign='center' sx={{ ml: 2 }} variant="h5">{datos.nombre}</Typography>
                </Box>
                {/* editar logotipo */}
                {editable &&
                    <>
                        <Box sx={{ mb: 2, display: 'flex' }}>
                            <Box sx={{ mx: 'auto', width: '200px', minHeight: '200px', border: 1 }}>
                                {datos.logotipo && <img width="200px" src={datos.logotipo.dataurl ?? datos.logotipo} />}
                            </Box>
                        </Box>
                        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                            <Button component="label" variant="contained" startIcon={<Folder />}>
                                Seleccionar <input name="logotipo" alt="Logotipo" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                            </Button>
                        </Box>
                    </>
                }
                {datos.descripcion &&
                    <>
                        <Divider />
                        <Box sx={{ my: 2 }}>
                            {editable ?
                                <TextField fullWidth name="descripcion" label="Descripción" value={datos.descripcion} multiline rows={3} onChange={setData} />
                                :
                                <Typography sx={{ ml: 2 }} variant="body1">{datos.descripcion}</Typography>
                            }
                            {!editable && datos.figura_juridica &&
                                <ul>
                                    <li>
                                        <Typography sx={{ ml: 2 }} variant="body1">Figura jurídica: {datos.figura_juridica}</Typography>
                                    </li>
                                </ul>
                            }
                        </Box>
                    </>
                }
                <Divider />
                {
                    editable ?
                        <>
                            <Box sx={{ mx: 2, pt: 2 }}>
                                <Typography variant="h6">Fotogalería de las instalaciones*</Typography>
                                <Typography variant="subtitle1">(Máximo 2 fotografías)</Typography>
                            </Box>
                            <Box sx={{ mx: 2, mt: 2, display: 'flex' }}>
                                {datos.galeria && Array.isArray(datos.galeria) && datos.galeria.map((image, index) => (
                                    <Box key={image.name} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                        <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(index, image.id ?? null)}>
                                            <Close />
                                        </IconButton>
                                        <img src={image.url_img ?? image.dataurl ?? image} alt={image.name} width="150px" />
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                                <Button disabled={datos.galeria && datos.galeria.length > 1} component="label" variant="contained" startIcon={<Folder />}>
                                    Agregar <input name="galeria" onInputCapture={(e) => handleInput(e, true)} type="file" accept='image/*' hidden />
                                </Button>
                            </Box>
                        </>
                        :
                        Object.values(datos.imagenes).filter(i => i.seccion == 'galeria').length > 0 &&
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, my: 2 }}>
                            {Object.values(datos.imagenes).filter(i => i.seccion == 'galeria').map((img) => {
                                return (
                                    <Box>
                                        <Box sx={{ width: { xs: '165px', xl: '220px' } }}>
                                            <img width="100%" src={img.url_img} />
                                        </Box>
                                    </Box>
                                )
                            })}
                        </Box>
                }
                <Divider />
                <Box sx={{ my: 2 }}>
                    {/* contacto */}
                    {editable ?
                        <Stack direction='column' spacing={1}>
                            <TextField sx={{ mb: 1 }} fullWidth name="nombre_contacto" label="Nombre del Contacto" value={datos.nombre_contacto} onChange={setData} />
                            <TextField fullWidth name="calle" label="Calle" value={datos.calle} onChange={setData} />
                            <Stack direction='row' spacing={1}>
                                <TextField fullWidth type="number" name="numero_ext" label="Número exterior" value={datos.numero_ext} onChange={setData} />
                                <TextField fullWidth name="numero_int" label="Número interior" value={datos.numero_int} onChange={setData} />
                                <TextField fullWidth type="number" name="codigo_postal" label="Código Postal" value={datos.codigo_postal} onChange={setData} />
                            </Stack>

                            <TextField fullWidth name="localidad" label="Localidad" value={datos.localidad} onChange={setData} />
                            <TextField fullWidth name="municipio" label="Municipio" value={datos.municipio} onChange={setData} />
                            <TextField fullWidth name="estado" label="Estado" value={datos.estado} onChange={setData} />
                            <TextField sx={{ my: 1 }} fullWidth name="email" label="Correo electrónico" value={datos.email} type="mail" onChange={setData} />
                            <TextField sx={{ my: 1 }} fullWidth name="telefono" label="Teléfono" value={datos.telefono} type="tel" onChange={setData} />
                            <TextField sx={{ mb: 1 }} fullWidth name="whatsapp" label="WhatsApp" value={datos.whatsapp} type="tel" onChange={setData} />
                            <TextField sx={{ mb: 1 }} fullWidth name="pagina_web" label="Página Web" value={datos.pagina_web} onChange={setData} />

                        </Stack>
                        :
                        <>
                            <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                <Person sx={{ mr: 2 }} />
                                <Typography>{datos.nombre_contacto} </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                <Place sx={{ mr: 2 }} />
                                <Typography>{datos.calle} {datos.numero_ext}{!['', null].includes(datos.numero_int) ? ' Int. ' + datos.numero_int : ''}, {datos.localidad}, {datos.municipio}, {datos.estado} C.P. {datos.codigo_postal}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                <Email sx={{ mr: 2 }} />
                                <Typography>{datos.email}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                <Phone sx={{ mr: 2 }} />
                                <Typography>{datos.telefono}</Typography>
                            </Box>
                            {
                                datos.whatsapp && datos.whatsapp.length > 8 &&
                                <Box sx={{ display: 'flex', my: 2, alignItems: 'center' }}>
                                    <WhatsApp sx={{ mr: 2 }} />
                                    <Typography>{datos.whatsapp} </Typography>
                                </Box>
                            }
                            {
                                datos.pagina_web && datos.pagina_web.length > 1 &&
                                <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                    <Language sx={{ mr: 2 }} />
                                    <Typography><a href={`https://${datos.pagina_web}`} target="_blank">{datos.pagina_web}</a></Typography>
                                </Box>
                            }
                        </>
                    }
                </Box>
                {/* mapa */}
                <Box sx={{ mb: 2 }}>
                    {editable ?
                        <Box sx={{ pb: 7 }}>
                            <Mapa editable={true} buscador={true} handleSelect={(newVal) => {
                                setMapa(() => {
                                    return `${newVal.lat},${newVal.lng}`;
                                })
                            }} />
                        </Box>
                        :
                        <iframe src={`https://maps.google.com/?q=${datos.geolocalizacion}&output=embed`} width="100%" height='300px' />
                    }
                </Box>
                <Box sx={{ my: 2 }}>
                    {editable ?
                        <Stack direction="column" spacing={1}>
                            <TextField label="TikTok" name="tiktok" value={datos.tiktok} onChange={setData} />
                            <TextField label="Facebook" name="facebook" value={datos.facebook} onChange={setData} />
                            <TextField label="X (antes twitter)" name="x_twitter" value={datos.x_twitter} onChange={setData} />
                            <TextField
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">@</InputAdornment>,
                                }}
                                label="Instagram"
                                name="instagram"
                                value={datos.instagram}
                                onChange={setData}
                            />
                        </Stack>
                        :
                        <Stack direction="column" spacing={1}>
                            <Box sx={{ alignItems: 'center', display: datos.tiktok ? 'flex' : 'none' }}>
                                <Icon sx={{ mr: 1 }}>
                                    <i class="fa-brands fa-tiktok"></i>
                                </Icon>
                                <Typography>{datos.tiktok}</Typography>
                            </Box>
                            <Box sx={{ alignItems: 'center', display: datos.facebook ? 'flex' : 'none' }}>
                                <Icon sx={{ mr: 1 }}>
                                    <i class="fa-brands fa-facebook"></i>
                                </Icon>
                                <Typography>{datos.facebook}</Typography>
                            </Box>
                            <Box sx={{ alignItems: 'center', display: datos.x_twitter ? 'flex' : 'none' }}>
                                <Icon sx={{ mr: 1 }}>
                                    <i class="fa-brands fa-twitter"></i>
                                </Icon>
                                <Typography>{datos.x_twitter}</Typography>
                            </Box>
                            <Box sx={{ alignItems: 'center', display: datos.instagram ? 'flex' : 'none' }}>
                                <Icon sx={{ mr: 1 }}>
                                    <i class="fa-brands fa-instagram"></i>
                                </Icon>
                                <Typography>{datos.instagram}</Typography>
                            </Box>


                        </Stack>
                    }
                </Box>


                {/* Guardar (edicion) */}
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                    <Divider />
                    {editable &&
                        <Button variant='contained' startIcon={<Save />} color='success' onClick={handleUpdate}>Guardar esta sección</Button>
                    }
                </Box>

                <Compartir nombre={datos.nombre} />

            </Box >
        )
    }
}



export default VistaIzquierda